import { render } from "./ShowLogisticsPartner.vue?vue&type=template&id=61a77f04"
import script from "./ShowLogisticsPartner.vue?vue&type=script&lang=js"
export * from "./ShowLogisticsPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__